<template lang='html'>
  <svg class='bottom-arch' fill-rule="evenodd" clip-rule="evenodd"
       xmlns="http://www.w3.org/2000/svg" aria-labelledby="title"
       viewBox="0 0 1920 240">
    <title id="title"></title>
    <g>
      <path fill="#082543"
            d="M1920,111.904l0,128.096l-1920,0l0,-132.536c390.745,104.115 1168.02,146.399 1763,34.536c60.63,-11.399 112.59,-21.405 157,-30.096Z"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FooterArch',
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bottom-arch {
    background-color: #ffffff;
    margin: -1px;
  }
</style>
